import { useEffect } from 'react'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'
import { type ConsolidationTerminalEvent, listenForAppEvents } from '../api/app-events'

function successMessage(event: ConsolidationTerminalEvent, openProject: () => void) {
  return (
    <span className="flex items-center gap-3">
      <span>
        Consolidated <strong>{event.areaName}</strong> in {event.projectName}.
      </span>
      <button className="font-semibold underline" onClick={openProject}>
        View
      </button>
    </span>
  )
}

export default function AppEventListener() {
  const navigate = useNavigate()

  useEffect(() => {
    const controller = new AbortController()
    const onEvent = (event: ConsolidationTerminalEvent) => {
      if (event.status === 'succeeded') {
        toast.success(
          successMessage(event, () => navigate(`/projects/${event.projectId}`)),
          {
            duration: 8_000,
          }
        )
        return
      }
      if (event.status === 'cancelled') {
        toast.success(`Consolidation cancelled for ${event.areaName}.`, { duration: 5_000 })
        return
      }
      const reason = event.errorMessage ?? 'The consolidation run did not complete.'
      toast.error(`Consolidation failed for ${event.areaName}: ${reason}`, { duration: 10_000 })
    }

    void listenForAppEvents(controller.signal, onEvent)
    return () => controller.abort()
  }, [navigate])

  return null
}
